var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("alert-modal", {
        ref: "confirm",
        attrs: { cancelable: "true", alertText: _vm.alertText },
        on: {
          confirm: _vm.confirmedDeleteBooking,
          cancel: _vm.cancelDeleteBooking,
        },
      }),
      _vm._v(" "),
      _c(
        "picture-modal",
        {
          ref: "modal",
          attrs: {
            "modal-class": _vm.isChannexBooking ? "booking--locked" : "",
            views: _vm.views,
            overrideTitle: _vm.bookingTitle,
            config: _vm.config,
          },
          on: { hide: _vm.hide },
        },
        [
          _c(
            "template",
            { slot: "tabOne" },
            [
              _c(
                "b-form",
                {
                  staticClass: "booking-form",
                  attrs: { autocomplete: "off" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.onSubmit.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "info-row",
                    {
                      staticClass: "guest-count-row info-main-row",
                      attrs: {
                        title: _vm.$t("booking_modal.guest_count"),
                        size: 4,
                      },
                    },
                    [
                      _c("b-form-input", {
                        staticClass: "input-info-field",
                        attrs: { id: "guest-count", type: "text" },
                        model: {
                          value: _vm.guestCount,
                          callback: function ($$v) {
                            _vm.guestCount = $$v
                          },
                          expression: "guestCount",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("Taggregator", {
                    ref: "addGuestsTags",
                    attrs: {
                      name: "guests",
                      placeholder: "Add Guest",
                      inputId: "add-guest-taggregator",
                      items: _vm.contacts,
                      selections: _vm.bookingGuests,
                      onAdd: _vm.addGuest,
                      onRemove: _vm.removeGuest,
                      minimum: 1,
                      quickAddCallback: _vm.quickAddGuest,
                      quickAddDescription:
                        "Please provide valid first and last names",
                      createItemCallback: _vm.showCreateGuest,
                      disabled: _vm.isChannexBooking,
                    },
                    on: {
                      "update:selections": function ($event) {
                        _vm.bookingGuests = $event
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "result",
                        fn: function ({ result }) {
                          return [
                            _c("span", { staticClass: "result-label" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(result.label) +
                                  "\n              "
                              ),
                              _c("i", { staticClass: "result-sub-label" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      result.email ? `(${result.email})` : null
                                    ) +
                                    "\n              "
                                ),
                              ]),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "selection",
                        fn: function ({ selection }) {
                          return [
                            _c("div", { staticClass: "card-text room-card" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "main-guest-button btn btn-xs",
                                  class: { active: _vm.isMainGuest(selection) },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setMainGuest(selection)
                                    },
                                  },
                                },
                                [
                                  !_vm.isMainGuest(selection)
                                    ? _c("i", {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover.top",
                                            value: "Make Booking Owner",
                                            expression: "'Make Booking Owner'",
                                            modifiers: {
                                              hover: true,
                                              top: true,
                                            },
                                          },
                                        ],
                                        staticClass: "fi fi-torso small",
                                      })
                                    : _c("i", {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover.top",
                                            value: "Booking Owner",
                                            expression: "'Booking Owner'",
                                            modifiers: {
                                              hover: true,
                                              top: true,
                                            },
                                          },
                                        ],
                                        staticClass: "fi fi-crown small",
                                      }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "reservation-label" }, [
                                _vm._v(_vm._s(selection.label)),
                              ]),
                              _vm._v(" "),
                              selection.email
                                ? _c("button", {
                                    directives: [
                                      {
                                        name: "clipboard",
                                        rawName: "v-clipboard:copy",
                                        value: selection.email,
                                        expression: "selection.email",
                                        arg: "copy",
                                      },
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.top",
                                        value:
                                          "Click To Copy Email: " +
                                          selection.email,
                                        expression:
                                          "\n                  'Click To Copy Email: ' + selection.email\n                ",
                                        modifiers: { hover: true, top: true },
                                      },
                                      {
                                        name: "clipboard",
                                        rawName: "v-clipboard:success",
                                        value: _vm.emailOnCopy,
                                        expression: "emailOnCopy",
                                        arg: "success",
                                      },
                                      {
                                        name: "clipboard",
                                        rawName: "v-clipboard:error",
                                        value: _vm.emailOnError,
                                        expression: "emailOnError",
                                        arg: "error",
                                      },
                                    ],
                                    staticClass:
                                      "phone-guest-button btn btn-xs fi-mail",
                                    attrs: { id: "copy_email_button" },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              selection.phone
                                ? _c("button", {
                                    directives: [
                                      {
                                        name: "clipboard",
                                        rawName: "v-clipboard:copy",
                                        value: selection.phone,
                                        expression: "selection.phone",
                                        arg: "copy",
                                      },
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.top",
                                        value:
                                          "Click To Copy Phone Number: " +
                                          selection.phone,
                                        expression:
                                          "\n                  'Click To Copy Phone Number: ' + selection.phone\n                ",
                                        modifiers: { hover: true, top: true },
                                      },
                                      {
                                        name: "clipboard",
                                        rawName: "v-clipboard:success",
                                        value: _vm.phoneOnCopy,
                                        expression: "phoneOnCopy",
                                        arg: "success",
                                      },
                                      {
                                        name: "clipboard",
                                        rawName: "v-clipboard:error",
                                        value: _vm.phoneOnError,
                                        expression: "phoneOnError",
                                        arg: "error",
                                      },
                                    ],
                                    staticClass:
                                      "phone-guest-button btn btn-xs fi-telephone",
                                    attrs: { id: "copy_phone_number_button" },
                                  })
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "align-room-select-right" },
                              [
                                _vm.bookingRooms.length > 1 &&
                                _vm.booking.reservations
                                  ? _c("b-form-select", {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover.top",
                                          value: "Assign Guest To Room",
                                          expression: "'Assign Guest To Room'",
                                          modifiers: { hover: true, top: true },
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        "value-field": "reservation_id",
                                        "text-field": "label",
                                        value: _vm.guestRoomTable[selection.id],
                                        options: _vm.bookingRooms,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onGuestRoomUpdate(
                                            $event,
                                            selection.id
                                          )
                                        },
                                      },
                                    })
                                  : _vm.bookingRooms.length == 1
                                  ? _c("div", { staticClass: "pt-1" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.bookingRooms[0].label) +
                                          "\n              "
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.roomsUpdating
                ? _c(
                    "div",
                    { staticClass: "payments-spinner" },
                    [_c("b-spinner", { attrs: { label: "Loading..." } })],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "tabTwo" },
            [
              _c(
                "b-form",
                {
                  staticClass: "booking-form",
                  attrs: { autocomplete: "off" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.onSubmit.apply(null, arguments)
                    },
                  },
                },
                [
                  !_vm.loadingUnits || _vm.loadingTimedOut
                    ? _c("Taggregator", {
                        attrs: {
                          inputId: "add-room-taggregator",
                          placeholder: "Add Room",
                          items: _vm.rooms,
                          selections: _vm.bookingRooms,
                          onRemove: _vm.removeRoom,
                          onAdd: _vm.addRoom,
                          name: "rooms",
                          minimum: 1,
                          disabled: _vm.isChannexBooking,
                        },
                        on: {
                          "update:selections": function ($event) {
                            _vm.bookingRooms = $event
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "result",
                              fn: function ({ result }) {
                                return [
                                  _c("span", { staticClass: "result-label" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(result.label) +
                                        "\n              "
                                    ),
                                    _c(
                                      "i",
                                      { staticClass: "result-sub-label" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              result.unitType
                                                ? `(${result.unitType})`
                                                : null
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "result-right-label" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              result.total_rate
                                                ? `${_vm.getVendor.local_currency}${result.total_rate} Total`
                                                : null
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "selection",
                              fn: function ({ selection }) {
                                return [
                                  _c("span", [
                                    selection.doorCode
                                      ? _c("button", {
                                          directives: [
                                            {
                                              name: "clipboard",
                                              rawName: "v-clipboard:copy",
                                              value: selection.doorCode,
                                              expression: "selection.doorCode",
                                              arg: "copy",
                                            },
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover.top",
                                              value:
                                                "Click To Copy Lock Code: " +
                                                selection.doorCode,
                                              expression:
                                                "\n                  'Click To Copy Lock Code: ' + selection.doorCode\n                ",
                                              modifiers: {
                                                hover: true,
                                                top: true,
                                              },
                                            },
                                            {
                                              name: "clipboard",
                                              rawName: "v-clipboard:success",
                                              value: _vm.lockOnCopy,
                                              expression: "lockOnCopy",
                                              arg: "success",
                                            },
                                            {
                                              name: "clipboard",
                                              rawName: "v-clipboard:error",
                                              value: _vm.lockOnError,
                                              expression: "lockOnError",
                                              arg: "error",
                                            },
                                          ],
                                          staticClass:
                                            "door-lock-button btn btn-xs fi-lock",
                                          attrs: {
                                            id: "copy_phone_number_button",
                                          },
                                        })
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "card-text room-card text-center booking-room-list",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "reservation-label room-label",
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(selection.label) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "reservation-dates" },
                                        [
                                          _c("v-date-picker", {
                                            staticClass: "daterange-picker",
                                            attrs: {
                                              "popover-direction": "bottom",
                                              "popover-align": "center",
                                              mode: "range",
                                              "show-caps": "",
                                              "disabled-dates":
                                                _vm.getDisabledDates(
                                                  selection.id,
                                                  selection
                                                ),
                                              "disabled-attribute":
                                                _vm.disabledAttributes,
                                              "drag-attribute":
                                                _vm.dragAttributes,
                                              "select-attribute":
                                                _vm.selectAttributes,
                                              "theme-styles": _vm.themeStyles,
                                              value:
                                                _vm.getRoomDateRange(selection),
                                            },
                                            on: {
                                              input: (v) =>
                                                _vm.setRoomDateRange(
                                                  v,
                                                  selection
                                                ),
                                            },
                                          }),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.formatBookingPeriod(
                                                  selection.startDate ||
                                                    _vm.newReservationStart
                                                )
                                              ) +
                                              "\n                -\n                " +
                                              _vm._s(
                                                _vm.formatBookingPeriod(
                                                  selection.endDate ||
                                                    _vm.newReservationEnd
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.booking.id
                                        ? _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName:
                                                    "v-b-tooltip.hover.top",
                                                  value: "Edit Room Rate",
                                                  expression:
                                                    "'Edit Room Rate'",
                                                  modifiers: {
                                                    hover: true,
                                                    top: true,
                                                  },
                                                },
                                              ],
                                              staticClass: "reservation-rate",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.passToRoomRateModal(
                                                    selection
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.getVendor.local_currency
                                                  ) +
                                                  _vm._s(
                                                    _vm.rateDisplay(selection)
                                                  ) +
                                                  "\n                "
                                              ),
                                              !_vm.isChannexBooking
                                                ? _c("i", {
                                                    staticClass: "fi-pencil",
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            { staticClass: "reservation-rate" },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.getVendor.local_currency
                                                  ) +
                                                  _vm._s(
                                                    _vm.rateDisplay(selection)
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4037163125
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loadingUnits && !_vm.loadingTimedOut
                    ? _c(
                        "div",
                        { staticClass: "accoms-spinner" },
                        [_c("b-spinner", { attrs: { label: "Loading..." } })],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.bookingRooms.length > 0
            ? _c(
                "template",
                { slot: "tabThree" },
                [
                  _c("b-form", [
                    _c(
                      "div",
                      { attrs: { id: "go-to-payments" } },
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                value: "Navigate to Guest Tab Section",
                                expression: "'Navigate to Guest Tab Section'",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            attrs: {
                              variant: "secondary",
                              disabled: !_vm.bookingTab || !_vm.bookingTab.id,
                            },
                            on: { click: _vm.goToPayments },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("booking_modal.goto_payments")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.paymentsLoading
                      ? _c(
                          "div",
                          { staticClass: "payments-spinner" },
                          [_c("b-spinner", { attrs: { label: "Loading..." } })],
                          1
                        )
                      : _vm.bookingTab && _vm.bookingTab.id
                      ? _c("div", { staticClass: "billing-summary" }, [
                          _c("div", { staticClass: "card mt-3" }, [
                            _c("div", { staticClass: "card-header" }, [
                              _c("strong", [_vm._v("Billing Summary")]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "card-body" }, [
                              _c("div", { staticClass: "row mb-2" }, [
                                _c("div", { staticClass: "col-6 text-left" }, [
                                  _vm._v("Invoice Number:"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6 text-right" }, [
                                  _vm._v(_vm._s(_vm.bookingTab.id)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row mb-2" }, [
                                _c("div", { staticClass: "col-6 text-left" }, [
                                  _vm._v("Balance Due:"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6 text-right" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.formatMoney(
                                          _vm.bookingTab.stats.balance_due || 0
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.bookingTab.stats.subtotal
                                ? _c("div", { staticClass: "row mb-2" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-6 text-left" },
                                      [_vm._v("Subtotal:")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-6 text-right" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.formatMoney(
                                                _vm.bookingTab.stats.subtotal ||
                                                  0
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.bookingTab.stats.card_hold
                                ? _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-6 text-left" },
                                      [_vm._v("Card Hold:")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-6 text-right" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.formatMoney(
                                                _vm.bookingTab.stats
                                                  .card_hold || 0
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "card-footer text-center" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-primary btn-sm",
                                    attrs: { disabled: !_vm.bookingTab.id },
                                    on: { click: _vm.goToPayments },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Open Full Billing Page\n              "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ])
                      : _c("div", { staticClass: "text-center mt-4" }, [
                          _c("p", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "booking_modal.save_booking_to_create_payment"
                                  ) ||
                                    "Please save booking first to access payment options"
                                ) +
                                "\n          "
                            ),
                          ]),
                        ]),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "template",
            { slot: "tabFour" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "booking-notes",
                  attrs: {
                    "label-for": "notesTextArea",
                    label: _vm.$t("booking_modal.reservation_special_requests"),
                  },
                },
                [
                  _c("b-form-textarea", {
                    attrs: { id: "notesTextArea", rows: "2", type: "text" },
                    model: {
                      value: _vm.formData.notes,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "notes", $$v)
                      },
                      expression: "formData.notes",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("booking-package-form", {
                ref: "packageForm",
                attrs: {
                  enabled: _vm.packageEnabled,
                  packageName: _vm.packageName,
                  packageRate: _vm.packageRate,
                  packageType: _vm.packageType,
                },
                on: {
                  "update:packageName": function ($event) {
                    _vm.packageName = $event
                  },
                  "update:package-name": function ($event) {
                    _vm.packageName = $event
                  },
                  "update:packageRate": function ($event) {
                    _vm.packageRate = $event
                  },
                  "update:package-rate": function ($event) {
                    _vm.packageRate = $event
                  },
                  "update:packageType": function ($event) {
                    _vm.packageType = $event
                  },
                  "update:package-type": function ($event) {
                    _vm.packageType = $event
                  },
                  toggle: _vm.togglePackages,
                  update: (newName) => {
                    _vm.packageName = newName
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("template", { slot: "tabFive" }, [
            _vm.paymentsLoading
              ? _c(
                  "div",
                  [_c("b-spinner", { attrs: { label: "Loading..." } })],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.paymentsLoading && _vm.bookingTab.id
              ? _c(
                  "div",
                  [
                    _c(
                      "b-form-group",
                      { attrs: { "label-for": "booking_notes" } },
                      [
                        _c("b-form-textarea", {
                          attrs: {
                            id: "booking_notes",
                            placeholder: _vm.$t("contact_modal.new_note"),
                            rows: "2",
                            type: "text",
                          },
                          model: {
                            value: _vm.newBookingNote,
                            callback: function ($$v) {
                              _vm.newBookingNote = $$v
                            },
                            expression: "newBookingNote",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover.top",
                            value: "Add note to Profile",
                            expression: "'Add note to Profile'",
                            modifiers: { hover: true, top: true },
                          },
                        ],
                        staticClass: "note-button",
                        attrs: { variant: "outline-secondary" },
                        on: { click: _vm.addBookingNote },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("contact_modal.add_note")) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.bookingNotes, function (bookingNote, index) {
                      return _c(
                        "b-card",
                        {
                          key: index,
                          attrs: { "bg-variant": "default" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c("small", { staticClass: "text-muted" }, [
                                      _vm._v(
                                        "Note Created: " +
                                          _vm._s(
                                            _vm.prettyDate(
                                              bookingNote.created_at
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                      _c("i", {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover.top",
                                            value: "Remove",
                                            expression: "'Remove'",
                                            modifiers: {
                                              hover: true,
                                              top: true,
                                            },
                                          },
                                        ],
                                        staticClass:
                                          "delete-icon float-right fi fi-x",
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeBookingNote(
                                              bookingNote.id
                                            )
                                          },
                                        },
                                      }),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c("b-card-text", { staticClass: "pre-line" }, [
                            _vm._v(_vm._s(bookingNote.content)),
                          ]),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.paymentsLoading && !_vm.bookingTab.id
              ? _c("div", [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("booking_modal.save_booking_to_create_note")
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("template", { slot: "modal-toolbar-buttons" }, [
            _c("span", { staticClass: "status-icons booking-action-btn" }, [
              _vm.onHold && (!_vm.bookingTab || !_vm.bookingTab.id)
                ? _c("i", { staticClass: "nav-icon booking-status disabled" }, [
                    _c("img", {
                      staticClass: "status-icon check-in-icon",
                      attrs: { src: _vm.checkinIcon },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.onHold && _vm.bookingTab && _vm.bookingTab.id
                ? _c("i", { staticClass: "nav-icon booking-status" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover.top",
                          value: "Check-In",
                          expression: "'Check-In'",
                          modifiers: { hover: true, top: true },
                        },
                      ],
                      staticClass: "status-icon check-in-icon",
                      attrs: { src: _vm.checkinIcon },
                      on: { click: _vm.showCheckInModal },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.checkedIn && (!_vm.bookingTab || !_vm.bookingTab.id)
                ? _c("i", { staticClass: "nav-icon booking-status disabled" }, [
                    _c("img", {
                      staticClass: "status-icon check-out-icon",
                      attrs: { src: _vm.checkoutIcon },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.checkedIn && _vm.bookingTab && _vm.bookingTab.id
                ? _c("i", { staticClass: "nav-icon booking-status" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover.top",
                          value: "Check-Out",
                          expression: "'Check-Out'",
                          modifiers: { hover: true, top: true },
                        },
                      ],
                      staticClass: "status-icon check-out-icon",
                      attrs: { src: _vm.checkoutIcon },
                      on: { click: _vm.showCheckOutModal },
                    }),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.formData.id
              ? _c(
                  "span",
                  {
                    staticClass: "booking-action-btn",
                    on: { click: _vm.deleteBooking },
                  },
                  [
                    !_vm.isConnected
                      ? _c("i", { staticClass: "backup-icon" }, [
                          _vm._v("Delete"),
                        ])
                      : _c("i", {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover.top",
                              value: "Delete Booking",
                              expression: "'Delete Booking'",
                              modifiers: { hover: true, top: true },
                            },
                          ],
                          staticClass:
                            "fi-trash delete-booking nav-icon modal-btn",
                        }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "booking-action-btn",
                on: { click: _vm.saveBooking },
              },
              [
                !_vm.isConnected
                  ? _c("i", { staticClass: "backup-icon" }, [_vm._v("Save")])
                  : _c("i", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover.top",
                          value: "Save Booking",
                          expression: "'Save Booking'",
                          modifiers: { hover: true, top: true },
                        },
                      ],
                      staticClass: "fi-save create-booking nav-icon modal-btn",
                    }),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "modal-btn", on: { click: _vm.hide } }, [
              !_vm.isConnected
                ? _c("i", { staticClass: "backup-icon" }, [_vm._v("Cancel")])
                : _c("i", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover.top",
                        value: "Close Window",
                        expression: "'Close Window'",
                        modifiers: { hover: true, top: true },
                      },
                    ],
                    staticClass: "fi-x cancel-booking nav-icon",
                  }),
            ]),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c("contact-modal", {
        ref: "newGuestModal",
        staticClass: "contact-modal-btn-new",
        attrs: { addGuest: _vm.createGuest, cancel: _vm.returnToBooking },
      }),
      _vm._v(" "),
      _c("check-in-modal", {
        ref: "checkInModal",
        on: { checkin: _vm.checkIn, cancel: _vm.checkIn },
      }),
      _vm._v(" "),
      _c("check-out-modal", {
        ref: "checkOutModal",
        on: { checkout: _vm.checkOut },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }